import { FC, memo, useCallback } from 'react';
import styled from 'styled-components';

import theme from 'theme';
import Modal from '@components/modal';
import { PremierText, DefaultText } from '@components/text';
import SkewedButton from '@components/buttons/SkewedButton';
import TouchableOpacity from '@components/buttons/TouchableOpacity';

const Title = styled(PremierText)`
  font-size: ${({ theme }) => theme.fonts.fontSize['3xl']};
  font-weight: bold;
  margin-bottom: 16px;
  text-shadow: ${({ theme }) =>
    `2px 2px 8px ${theme.colors.black}${theme.opacity[50]}`};
`;

const Subtitle = styled(DefaultText)`
  font-size: ${({ theme }) => theme.fonts.fontSize.base};
  font-weight: ${({ theme }) => theme.fonts.fontWeight.semiBold};
  margin-bottom: 32px;
  line-height: 1.5;
  text-align: center;
  text-shadow: ${({ theme }) =>
    `2px 2px 8px ${theme.colors.black}${theme.opacity[50]}`};
`;

const Button = styled(SkewedButton)`
  min-width: 200px;
  background: transparent;
  border: 0.5px solid ${({ theme }) => theme.colors.white};
`;

const MaybeLater = styled(TouchableOpacity)`
  margin-top: 24px;
  font-size: ${({ theme }) => theme.fonts.fontSize.lg};

  &:hover {
    opacity: 0.8;
  }
`;

const MaybeLaterText = styled(DefaultText)`
  font-size: ${({ theme }) => theme.fonts.fontSize.base};
  font-weight: ${({ theme }) => theme.fonts.fontWeight.semiBold};
  color: ${({ theme }) => theme.colors.white};
  text-shadow: ${({ theme }) =>
    `2px 2px 8px ${theme.colors.black}${theme.opacity[50]}`};
`;

type Props = {
  isShown: boolean;
  onConfirm?: () => void;
  onClose: () => void;
};

const DownloadAppModal: FC<Props> = ({
  isShown,
  onConfirm: _onConfirm,
  onClose,
}) => {
  const handleDownload = useCallback(() => {
    const userAgent = navigator.userAgent || navigator.vendor;

    if (/android/i.test(userAgent)) {
      window.location.href = `https://play.google.com/store/apps/details?id=${process.env.REACT_APP_ANDROID_APP_ID}`;
    } else if (
      /iPad|iPhone|iPod/.test(userAgent) &&
      !(window as unknown as { MSStream?: unknown }).MSStream
    ) {
      window.location.href = `https://apps.apple.com/app/${process.env.REACT_APP_IOS_APP_ID}`;
    } else {
      window.location.href = `https://play.google.com/store/apps/details?id=${process.env.REACT_APP_ANDROID_APP_ID}`;
    }
  }, []);

  return (
    <Modal
      isShown={isShown}
      onClose={onClose}
      isActionable={false}
      style={{
        background: `linear-gradient(135deg, #375CD7 0%, #8C06CD 40%, #EB1F24 100%)`,
        border: 'none',
      }}
    >
      <Title>PLAY THE FULL 90!</Title>

      <Subtitle>
        This is just a highlight. For the full experience and to have your say
        LIVE — download the app and sign up.
      </Subtitle>

      <Button
        onClick={handleDownload}
        isBorder
        textStyle={{
          fontSize: theme.fonts.fontSize.lg,
          textShadow: `2px 2px 8px ${theme.colors.black}${theme.opacity[50]}`,
        }}
      >
        DOWNLOAD & JOIN
      </Button>

      <MaybeLater onClick={onClose}>
        <MaybeLaterText>Maybe later</MaybeLaterText>
      </MaybeLater>
    </Modal>
  );
};

export default memo(DownloadAppModal);
